import {listFiltersPlaces} from '@adv-mt/mt-list-filters'

export const NO_OP = () => {}

export const SEARCH_TOPBAR_PLACES = {
  ADS_LIST: 'adsList'
}

export const SEARCH_TOPBAR_PLACES_DICTIONARY = {
  [SEARCH_TOPBAR_PLACES.ADS_LIST]: listFiltersPlaces.TOPBAR
}
